import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ContractorTransferCreated } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  options?: Omit<UseMutationOptions<ContractorTransferCreated, Error, number>, 'mutationKey' | 'mutationFn'>
}

export const useRetryContractorTransferRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useMutation<ContractorTransferCreated, Error, number>(
    [Entities.ContractorTransfers, 'retry'],
    async (transferId: number) => {
      const { data } = await api.v1AdminContractorTransfersTransferIdRetryPost(transferId)
      return data as unknown as ContractorTransferCreated
    },
    { ...options }
  )
}
